import { render, staticRenderFns } from "./boxMessage.vue?vue&type=template&id=2ff4395a&scoped=true&"
import script from "./boxMessage.vue?vue&type=script&lang=js&"
export * from "./boxMessage.vue?vue&type=script&lang=js&"
import style0 from "./boxMessage.vue?vue&type=style&index=0&id=2ff4395a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff4395a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ff4395a')) {
      api.createRecord('2ff4395a', component.options)
    } else {
      api.reload('2ff4395a', component.options)
    }
    module.hot.accept("./boxMessage.vue?vue&type=template&id=2ff4395a&scoped=true&", function () {
      api.rerender('2ff4395a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/components/boxMessage.vue"
export default component.exports